import {XMarkIcon} from '@heroicons/react/24/outline';
import React from 'react';
import {Badge} from '../../../components/Badge';

interface IProps {
  key?: string;
  tag: string;
  media?: {id: string};
  onClick?: (id: string | undefined, tag: string) => void;
}

const Tag: React.FC<IProps> = ({key, tag, media, onClick}) => (
  <Badge
    key={key}
    label={
      <div className="flex items-center flex-nowrap gap-1 cursor-default">
        {tag}
        {onClick ? (
          <XMarkIcon
            height={16}
            width={16}
            onClick={() => onClick(media?.id, tag)}
          />
        ) : null}
      </div>
    }
    backgroundColor={'#2563eb'}
    color="#fff"
    size={'small'}
  />
);

export default Tag;
